import React from "react";
import { scStringType } from "../../types";

var OnboardingFeatureInfo = function OnboardingFeatureInfo(props) {
  var Header = props.Header,
      Description = props.Description;
  return /*#__PURE__*/React.createElement("div", {
    className: "onboarding-feature--info"
  }, /*#__PURE__*/React.createElement("h3", null, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("p", null, Description === null || Description === void 0 ? void 0 : Description.value));
};

export default OnboardingFeatureInfo;